import styled from 'styled-components'
import { Colors } from 'styles/app-styles'

import { Checkbox } from "primereact/checkbox"

export const Checkbox_s = styled(Checkbox)`
  border: 1px solid ${Colors.towerGrey};
  border-radius: 2px;
  height: 16px !important;
  margin: 0 auto !important;
  width: 16px !important;

  .p-checkbox-box.p-component.p-highlight {
    height: 16px !important;
    width: 16px !important;
    margin: 0 auto !important;
    .p-checkbox-icon {
      display: block;
      margin-right: 4px;
    }
  }
`